<template>
    <div>
        <treeselect v-model="selectedSite" :options="options" placeholder="Valitse..." name="site"
                    @input="onSiteSelected" required/>
    </div>
</template>

<script>
  // import the component
  import Treeselect from "@riophae/vue-treeselect";
  // import the styles
  import "@riophae/vue-treeselect/dist/vue-treeselect.css";
  import {TicketSiteTransformer} from "./TicketSitesTransformer";

  export default {
    props: ["sites", "selected"],

    components: {Treeselect},

    data() {
      return {
        selectedSite: null,
        options: []
      };
    },

    created() {
      console.log("OnSiteSelect mounted", this.sites);
      this.options = this.sites.map(s => new TicketSiteTransformer().toClass(s));

      if (this.selected) {
        this.selectedSite = this.selected;
      }
    },

    methods: {
      onSiteSelected(e) {
        console.log("onSiteSelected", e, this.selectedSite);
        const node = this.findNodeById(e);
        console.log({node});
        if (!node.project_id) {
          // Reset selected site if user selects the root level node which is project
          this.$nextTick(() => (this.selectedSite = null));
        }
      },

      findNodeById(siteId) {
        var foundNode = {};
        const localFind = items => {
          items.forEach(item => {
            if (item.id === siteId) {
              foundNode = item;
            } else if (item.children) {
              localFind(item.children);
            }
          });
        };
        localFind(this.options);
        return foundNode;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// resources/js/tickets/components/SiteSelect.vue